export const getFormattedDate = ({
  years = 0,
  months = 0,
  days = 0,
}: {
  years?: number;
  months?: number;
  days?: number;
} = {}): string => {
  const today = new Date(Date.now());
  const date = new Date(today.getFullYear() + years, today.getMonth() + months, today.getDate() + days);

  return date.toISOString().substring(0, 10);
};
